'use client';
import React, { useEffect, useState } from 'react';

import { useAppSelector } from '@/lib/redux/hooks';
import WishlistTableRow from './WishlistTableRow';
const WishlistTable = () => {
  const wishlistItems = useAppSelector((state) => state.wishlist.items);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null; // or a loading spinner
  }
  return (
    <div className="cart__product table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Price</th>
            <th>Add To Cart</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {wishlistItems.length > 0 ? (
            wishlistItems.map((item, i) => (
              <WishlistTableRow key={i} product={item} />
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center">
                Your wishlist is empty.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WishlistTable;
